import { gql, TypedDocumentNode } from "@apollo/client";

import { Template, QueryTemplateArgs } from "types/generated";

type GetTemplateData = {
  template: Template;
};

export const GET_TEMPLATE: TypedDocumentNode<GetTemplateData, QueryTemplateArgs> =
  gql`
    query GetTemplate($id: ID!) {
      template(id: $id) {
        id
        allowedActions
        canDelete
        description
        labels
        name
        createdAt
        updatedAt
        latestVersion {
          id
          version
        }
        space {
          accessLevel
          id
          name
        }
        ulid
      }
    }
  `;
